import React from 'react';
import { Link } from 'react-router-dom';
import CONSTANT from './../../../constant';

import { getNotingsList } from '../../../actions/MasterAction';
import Header from '../../../component/common/AdminHeader';
import { onChange, getDateParts } from './../../../utils';


class ComponentName extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            sort: { name: 'sort', value: '1', error: '' },
            page: 1,
            limit: 10,
            list: undefined,
            showLoader: true
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        this.loadList();
    }

    render() {
        
        const { list, sort } = this.state;
        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12">
                                    <h1 className="page-title">All Noting</h1>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-6">
                                    <Link to={CONSTANT.component.adminAddNoting.url} className="btn btn-sm submit-button">
                                        <i className="fa fa-plus-circle mr-2" />
                                        Add Noting
                                    </Link>
                                </div>
                                <div className="col-md-3"></div>
                                <div className="col-md-3">
                                    {/* <select
                                        name={sort.name}
                                        value={sort.value}
                                        onChange={this.onChange}
                                        className="form-control"
                                    >
                                        <option value='1'>Sort by - Name Asc</option>
                                    </select> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 mt-3">
                                    <div className="list-container">
                                        <div className="table-container">
                                        <div className="table-wrapper radius-4">
                                        <table className="tablen">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="text-nowrap">#</th>
                                                    <th scope="col" className="text-nowrap">Noting</th>
                                                    <th scope="col" className="text-nowrap">Available</th>
                                                    <th scope="col" className="text-nowrap">Modified by</th>
                                                    <th scope="col" className="text-nowrap">Modified on</th>

                                                    <th scope="col"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    list === undefined &&
                                                    <tr>
                                                        <td colSpan={6} className="text-center">Loading...</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.length === 0 &&
                                                    <tr>
                                                        <td colSpan={6} className="text-center">No records found</td>
                                                    </tr>
                                                }
                                                {
                                                    list !== undefined && list.map((item: any, index: number) => {
                                                        const dt = getDateParts(item.modifiedOn);
                                                        return (
                                                            <tr className="c-pointer" key={index}>
                                                                <td>{index + 1}</td>
                                                                {
                                                                <td>{item.name}</td>
                                                                }
                                                                <td>{item.available ? <i className="fa fa-check-circle text-success"></i> : <i className="fa fa-times-circle text-danger"></i>}</td>
                                                                <td>{item.modifiedBy ? item.modifiedByName : '-'}</td>
                                                                <td>{`${dt.date} ${dt.monthName} ${dt.year} ${dt.hour}:${dt.minute}:${dt.seconds} ${dt.amOrpm}`}</td>
                                                                <td><i className="fa fa-pencil editicnot" onClick={() => this.editNoting(item.code)} /></td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    loadList = () => {
        getNotingsList().then((res: any) => {
            if (res)
                this.setState({ list: res.result
                //     .filter((data:any,index:any)=>{
                //     return data.name!=="अनुमोदित  / Approved" ? data :data.isApprovingAuthority===true ? data :''
                // })
             });
        })
    }

    onChange = (e: any) => {
        onChange(this, e.target.name, e.target.value, () => {
            this.loadList();
        });
    }

    editNoting = (code: any) => {
        this.props.history.push(CONSTANT.component.adminEditNoting.url.replace(':code', code))
    }
}

export default ComponentName;